import React from 'react';
import { string, bool, func, oneOf } from 'prop-types';
import { Modal } from 'antd';
import { FlexContainer, Icon, Text, Button } from '../common';

const ModalAlert = ({ visible, setVisible, status, message }) => {
    const handleClose = () => setVisible(false);

    const renderBody = () => {
        if (status === 'success') {
            return (
                <FlexContainer style={{ margin: '30px 0px' }} align='center' direction='column'>
                    <Icon name='check-mark' color='#1fa02e' size={80} bottom={20} />
                    <Text text={message || 'Operación realizada correctamente'} strong style={{ fontSize: 16, textAlign: "center" }} />
                </FlexContainer>
            );
        }
        if (status === 'error') {
            return (
                <FlexContainer style={{ margin: '30px 0px' }} align='center' direction='column'>
                    <Icon name='new-cross' color='red' size={80} bottom={20} />
                    <Text text={message || 'Ups, algo falló'} strong style={{ fontSize: 16, textAlign: "center" }} />
                </FlexContainer>
            );
        }
        return null;
    };

    return (
        <Modal
            visible={visible}
            footer={null}
            closable={false}
            width={450}
            destroyOnClose
            onCancel={handleClose}
        >
            {renderBody()}
            <FlexContainer justify='center' align='center' style={{ width: '100%' }}>
                <Button
                    text="Cerrar"
                    style={{ width: '100px', margin: 0 }}
                    onClick={handleClose}
                />
            </FlexContainer>
        </Modal>
    );
};

ModalAlert.propTypes = {
    visible: bool.isRequired,
    setVisible: func.isRequired,
    status: oneOf(['success', 'error']).isRequired,
    message: string
};

export default ModalAlert;